export default {"src":"/_next/static/image/public/icons/arrow-down.28bb872ee743f68c4dc5fccf16660ec4.svg","height":20,"width":20};